import { create } from 'zustand';

/**
 * Animator Control (Phase 2A) — pont interne entre ScreenApp (qui lit le signal
 * `launchRequest` dans Firestore) et le bridge de l'iframe (`useWebViewPlugin`,
 * qui poste l'ordre dans le jeu). Découple les deux sans faire descendre un prop
 * à travers ScreenManager / GameRunner.
 *
 * `nonce` = horodatage du dernier appui « Lancer » relayé par l'écran (null tant
 * qu'aucun appui). Le producteur n'y pousse QUE les vrais appuis (il ignore la
 * valeur présente au montage → pas de relance fantôme au rechargement de l'écran).
 */
type RemoteLaunchStore = {
    nonce: number | null;
    fire: (nonce: number) => void;
};

export const useRemoteLaunch = create<RemoteLaunchStore>((set) => ({
    nonce: null,
    fire: (nonce: number) => set({ nonce }),
}));
